import React, { useState } from 'react'
import { Form, FormGroup, FormControl, Button } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'

export const Reports = () => {
  let [startDate, setStartDate] = useState('')
  let [endDate, setEndDate] = useState('')
  let [localError, setLocalError] = useState('')
  const handleDateChange = (evt, dateName) => {
    if (dateName === 'start') {
      setStartDate(evt.target.value)
    } else {
      setEndDate(evt.target.value)
    }
  }

  const genReport = async e => {
    e.preventDefault()
    setLocalError('')
    try {
      await client.post(endpoints.generateReport(), {
        startDate,
        endDate,
      })
      location.reload()
    } catch (err) {
      console.error(err)
      if (err.response.status === 400) {
        setLocalError(err.response.data.msg)
      } else {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={`There was an error trying to generate the report. ${err}`}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
          sticky: true,
        })
      }
    }
  }

  return (
    <React.Fragment>
      <h2>Reports</h2>
      <p>
        This report will generate a CSV File that includes all codes that have
        been redeemed at any point in time from Access Code Orders that were
        paid for during the period specified.
      </p>
      <p>The report is inclusive of both days selected.</p>
      <Form horizontal onSubmit={e => genReport(e)}>
        <FormGroup className="d-flex">
          <input
            className="w-25 form-control"
            type="date"
            onChange={e => handleDateChange(e, 'start')}
            required
          />
          <span className="mx-3 mt-3">through</span>
          <FormControl
            type="date"
            className="w-25"
            onChange={e => handleDateChange(e, 'end')}
            required
          />
        </FormGroup>
        {localError && <div className="text-danger">{localError}</div>}
        <Button
          className="mt-5 btn-myed btn-primary-myed text-white"
          type="submit"
        >
          <i className="fal fa-rocket mr-2" />
          Generate Report
        </Button>
      </Form>
    </React.Fragment>
  )
}
